import { ChildrenStoreData, Observation } from "src/shared/types/src";
import { getAxiosInstance } from "../api";
import { ACTIVITY_TYPE, DATE_FORMATS, PDF_BOOK_PAGE_SIZE } from "src/shared/config/src";
import { dateFormatter } from "src/shared/utils/src";

export const fetchTimeline = async ({ child, page, filterObj }: { child: ChildrenStoreData, page: number, filterObj: any }): Promise<any> => {
    let queryObj: any = { page };
    if (filterObj && Object.keys(filterObj).length > 0) {
        queryObj = { ...queryObj, ...filterObj };
    }
    const { retryAxios } = getAxiosInstance();
    return retryAxios.get(`/timeline/child/${child.childId}?${new URLSearchParams(queryObj).toString()}`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const fetchTodayDiary = async ({ child }: { child: ChildrenStoreData }): Promise<any> => {
    let queryObj: any = { page: 1 };
    const currentDate = dateFormatter(new Date(), DATE_FORMATS.YMD);
    const activityTypeFilter = [
        ACTIVITY_TYPE.DAILY_DIARY,
        ACTIVITY_TYPE.ACCIDENT_SHEET,
        ACTIVITY_TYPE.REPORTS,
        ACTIVITY_TYPE.MEDICINE_FORM
    ]
    queryObj = {
        ...queryObj,
        activityType: activityTypeFilter.join(","),
        from: currentDate,
        to: currentDate
    };
    const { retryAxios } = getAxiosInstance();
    return retryAxios.get(`/timeline/child/${child.childId}?${new URLSearchParams(queryObj).toString()}`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}


export const fetchObservations = async ({
  page,
  filterObj,
  childId,
}: {
  page: number;
  filterObj: Partial<{
    page: number;
    from: string;
    to: string;
  }>;
  childId: string;
}): Promise<{
  child: {
    name: string;
    dob: string;
  }
  list: Observation[];
  meta: {
    last_page: number;
    total: number;
  };
}> => {
  try {
    let queryObj: any = { page, per_page: PDF_BOOK_PAGE_SIZE };
    if (filterObj && Object.keys(filterObj).length > 0) {
      queryObj = { ...queryObj, ...filterObj };
    }
    const { retryAxios } = getAxiosInstance();

    const res = await retryAxios.get(
      `/child/${childId}/observations?${new URLSearchParams(
        queryObj
      ).toString()}`
    );
    const response = res.data;
    if (response && response.status === "success") {
      return response?.data?.observations;
    }
    throw new Error("Error occured while fetching observations");
  } catch (e) {
    throw e;
  }
};
